import { ROLES } from '@auth';

export const MERCHANT_HOME_ROUTE = '/claims/todo';
export const DEVELOPER_HOME_ROUTE = '/developer/apps';

// Landing route for an authenticated user (ENG-5562). Developer-org accounts carry the global
// `developer` role and have no store attached, so the merchant home is entitlement-blocked for
// them — every post-login and fallback navigation must resolve through this helper instead of
// hardcoding /claims/todo, or storeless developers dead-end on /unauthorized. An unknown or
// unhydrated role falls back to the merchant home (previous behavior).
export function resolveHomeRoute(roleName?: string | null): string {
  return roleName === ROLES.developer ? DEVELOPER_HOME_ROUTE : MERCHANT_HOME_ROUTE;
}
